// @flow

import * as React from 'react';

type Props = {
  children: React.Node
};

export default function Heading(props: Props) {
  return <h2 {...props} className="h4 semi-bold" />;
}
